import { lazy } from 'react';
import Loadable from 'components/Loadable';

const Administration = Loadable(lazy(() => import('pages/administration/Administration')));
const COEAdministration = Loadable(lazy(() => import('pages/administration/COE-Administration')));
const DetailsAdministration = Loadable(lazy(() => import('pages/administration/Details-Adminstration')));
const AdministrationExtended = Loadable(lazy(() => import('pages/administration/AdministrationExtended')));
const COEAdministrationExtended = Loadable(lazy(() => import('pages/administration/COE-AdministrationExtended')));

const AdministrationRoutes = [
	{
		path: 'administration',
		children: [
			{ index: true, element: <Administration /> },
			{ path: 'coe-administration', element: <COEAdministration /> },
			{ path: 'details-administration', element: <DetailsAdministration /> },
			{
				path: 'administration-item-details',
				children: [
					{ index: true, element: <AdministrationExtended /> },
					{ path: 'coe', element: <COEAdministrationExtended /> },
				],
			},
		],
	},
];

export default AdministrationRoutes;
